import { cn } from '@/lib/utils';

export function WinnerBadge({ className }: { className?: string }) {
  return (
    <span
      data-name="RAFFLE_WINNER_BADGE"
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-[#FF6B3D] px-[18px] py-[7px] font-screen-body text-[14px] font-bold uppercase tracking-[0.18em] text-white shadow-[0_0_28px_rgba(255,107,61,0.55)]',
        className,
      )}
    >
      <span aria-hidden className="text-[11px] leading-none">
        ✦
      </span>
      Winner
    </span>
  );
}
